import { useState } from "react";
import { fetchJson } from "../lib/fetchJson";

const INITIAL_INTEGRATION_DIAGNOSTICS = {
  error: "",
  facebook: null,
  loading: false,
  ozontel: null,
};

export function useCRMContext() {
  const [context, setContext] = useState({
    teams: [],
    users: [],
    lead_sources: [],
    disposition_groups: [],
    geographies: [],
    available_regions: [],
    available_cities: [],
    phone_reveal_alerts: [],
  });
  const [contextReady, setContextReady] = useState(false);
  const [integrationDiagnostics, setIntegrationDiagnostics] = useState(
    INITIAL_INTEGRATION_DIAGNOSTICS,
  );

  async function loadContext() {
    const payload = await fetchJson("/api/crm/context/");
    setContext(payload);
    setContextReady(true);
    return payload;
  }

  async function loadIntegrationDiagnostics() {
    setIntegrationDiagnostics((current) => ({
      ...current,
      error: "",
      loading: true,
    }));

    const [facebookResult, ozontelResult] = await Promise.allSettled([
      fetchJson("/api/crm/integrations/facebook-leads/"),
      fetchJson("/api/crm/integrations/ozontel/webhook/"),
    ]);

    const nextError = [facebookResult, ozontelResult]
      .filter((result) => result.status === "rejected")
      .map((result) => result.reason?.message)
      .filter(Boolean)
      .join(" ");

    setIntegrationDiagnostics({
      error: nextError,
      facebook: facebookResult.status === "fulfilled" ? facebookResult.value : null,
      loading: false,
      ozontel: ozontelResult.status === "fulfilled" ? ozontelResult.value : null,
    });
  }

  function resetContext() {
    setContext({
      teams: [],
      users: [],
      lead_sources: [],
      disposition_groups: [],
      geographies: [],
      available_regions: [],
      available_cities: [],
      phone_reveal_alerts: [],
    });
    setContextReady(false);
    setIntegrationDiagnostics(INITIAL_INTEGRATION_DIAGNOSTICS);
  }

  return {
    context,
    contextReady,
    integrationDiagnostics,
    loadContext,
    loadIntegrationDiagnostics,
    resetContext,
    setContext,
    setContextReady,
    setIntegrationDiagnostics,
  };
}
